import { render, staticRenderFns } from "./FeaturedEvents.vue?vue&type=template&id=3262de37&scoped=true"
import script from "./FeaturedEvents.vue?vue&type=script&lang=js"
export * from "./FeaturedEvents.vue?vue&type=script&lang=js"
import style0 from "./FeaturedEvents.vue?vue&type=style&index=0&id=3262de37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3262de37",
  null
  
)

export default component.exports